import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import QuiSommesNous from './pages/QuiSommesNous';
import Residence from './pages/Residence';
import Teleconciergerie from './pages/Teleconciergerie';
import MentionsLegales from './pages/MentionsLegales';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="/residence" element={<Residence />} />
          <Route path="/teleconciergerie" element={<Teleconciergerie />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
